import React from "react";
import config from "../../../src/globs/config";
import moment from "moment";
import classNames from "classnames";
import LoadingState from "../../components/common/loading-state";
import gaPush from "../../globs/utils/google-analytics";
import { DELIVERY_INCO_TERM } from "../../globs/constants";
import FormattedCurrencyNumberCustom from "../formatted-currency-number-custom";
import { getInstrumentedAxiosInstance } from "../../globs/ajax-proxy";
import LocationMapIcon from "./location-map.png";
import { DynamicMap as Map } from "./dynamicMap";
import FormattedNumberCustom from "../../util/formatted-number-custom";

class OrderDetail extends React.Component {
  constructor(props) {
    const sdoStatuses = props.user.settings_data.SDO_STATUSES || {};
    const ddpStatus =
      sdoStatuses &&
      sdoStatuses.ddp_status &&
      sdoStatuses.ddp_status.split(",");
    const exwStatus =
      sdoStatuses &&
      sdoStatuses.exw_status &&
      sdoStatuses.exw_status.split(",");
    super(props);
    this.state = {
      isHeaderVisible: true,
      isFooterVisible: true,
      isInputFocused: false,
      setCheck: "",
      deliveredSrc: "",
      userComment: "",
      totalTons: 0,
      totalBags: 0,
      imagePreviewUrl: "",
      orderDetail: {},
      showLoader: true,
      divOpacity: true,
      ddpStatus,
      exwStatus,
      openMap: null,
      mapData: {},
      mapError: false,
      isMapLoading: true,
      currentDate: moment(new Date()),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    this.fireGaEventPagePath = (path) => {
      gaPush("pageview", {
        path,
      });
    };
    const { props } = this;
    // Only update when API status changes from PENDING to complete
    // Prevent infinite loops in React 19
    if (
      prevProps.ajaxStatuses.orderDetails === "PENDING" &&
      props.ajaxStatuses.orderDetails === ""
    ) {
      let totalTons = 0;
      let totalBags = 0;
      if (props.orderDetails.sap_order_line_items) {
        props.orderDetails.sap_order_line_items.forEach((product) => {
          if (product.ordered_uom === "TM") {
            totalTons += product.quantity;
          } else {
            totalBags += product.quantity * 20;
          }
        });
      }

      // Only update if state actually needs to change
      if (this.state.orderDetail !== props.orderDetails ||
          this.state.showLoader !== false ||
          this.state.divOpacity !== false ||
          this.state.totalTons !== totalTons ||
          this.state.totalBags !== totalBags) {
        this.setState({
          orderDetail: props.orderDetails,
          showLoader: false,
          divOpacity: false,
          totalTons,
          totalBags,
        });
      }
    }
  }

  componentDidMount() {
    this.fireGaEventPagePath(window.location.pathname + window.location.search);
    const { props } = this;
    // const orderStatus = (props.orderDetail && props.orderDetail.customer_order_status_desc === 'Finished') ? 'Finished' : 'Pending';
    const salesOfficerId = props.user.id;
    console.log("cccccccc", salesOfficerId);
    const params = this.props.match.params;
    const searchParams =
      this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isJDE" ||
      this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isSageAPI"
        ? props.history.location.search
        : "";
    const order_detail_url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${params.customerId}/sap_digital_orders/${params.orderNumber}${searchParams}`;
    props.dataLoad({
      key: "orderDetails",
      url: order_detail_url,
    });

    // console.log('++++++++++++:::::',props.user.settings_data.DIGITAL_ORDER_SYSTEM);
  }

  toggleMap = (sapSodOrder, index) => {
    const { props } = this;
    const bodyPassed = { truckPlateNumber: sapSodOrder.truck_plate_no };
    const _url = props.user.href;
    const salesOfficerId = props.user.id;

    console.log("click work", _url, bodyPassed, salesOfficerId);
    const o = this.state.openMap === index ? null : index;
    this.setState({ isMapLoading: true, mapError: false, mapData: {} });
    console.log("map is loading----------");
    this.setState({ openMap: o }, () => {
      if (o === index) {
        getInstrumentedAxiosInstance()
          .post(
            `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}/truck_location`,
            bodyPassed
          )
          .then(
            (data) => {
              console.log("get wala ++++++++++++", data);
              // this.setState({ mapData: data.data, openMap: o });
              this.setState({
                mapData: data.data,
                isMapLoading: false,
                mapError: Object.keys(data.data).length === 0,
              });
            },
            (error) => {
              console.log("error in mapppp --------->", error);
              this.setState({ mapError: true, mapData: {} });
            }
          );
      } else {
        this.setState({ openMap: o });
      }
    });
  };

  getDigitalOrder = (id) => {
    const { props } = this;
    const salesOfficerId = 71;
    const params = this.props.match.params;
    const order_detail_url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${params.customerId}/sap_digital_orders/${params.orderNumber}`;
    props.dataLoad({
      key: "orderDetails",
      url: order_detail_url,
    });
  };
  backPage = () => {
    // const key = 'orderDetailsPage';
    const params = this.props.match.params;
    this.props.history.push(`/customer-orders/${params.customerId}`);
    // props.loadMoreOrder({
    //     key: key,
    // });
  };

  fireGaEventPagePath = (path) => {
    gaPush("pageview", {
      path,
    });
  };

  fireGaEvent = (act, action, labelIn) => {
    const label = `${labelIn}`;
    gaPush("event", {
      category: act,
      action,
      label,
    });
  };

  showUnitConditional = () => {
    const { props, state } = this;
    if (
      props.orderDetails &&
      props.orderDetails.order_total_tons &&
      props.orderDetails.order_total_tons.length > 0
    ) {
      const qty =
        props.orderDetails.order_total_tons[0].uom_code ===
        props.orderDetails.order_total_tons[0].input_uom
          ? props.orderDetails.order_total_tons[0].sum
          : props.orderDetails.order_total_tons[0].sum /
            props.orderDetails.order_total_tons[0].conversion_factor;
      const convertQty =
        props.orderDetails.order_total_tons[0].uom_code ===
        props.orderDetails.order_total_tons[0].input_uom
          ? props.orderDetails.order_total_tons[0].sum *
            props.orderDetails.order_total_tons[0].conversion_factor
          : props.orderDetails.order_total_tons[0].sum;
      console.log(
        "props.orderDetails.remaining_delivery_quantity===>",
        props.orderDetails.remaining_delivery_quantity
      );
      if (props.user.locale === "en-AE") {
        const orderQty = props.orderDetails.order_total_tons.reduce((a, b) => {
          return a + b.sum;
        }, 0);
        return (
          <span>
            <span>
              {" "}
              |{" "}
              <FormattedNumberCustom
                value={state.orderDetail.remaining_delivery_quantity || 0}
              />
              /<FormattedNumberCustom value={orderQty} />{" "}
              {orderQty === 1
                ? props.orderDetails.order_total_tons[0].input_uom_name
                : props.orderDetails.order_total_tons[0].input_uom_name_plural}
            </span>
            {/* {
              props.orderDetails.order_total_tons[0].show_conversion &&
              <span> | <FormattedNumberCustom
                value={convertQty}
              /> {convertQty === 1 ? props.orderDetails.order_total_tons[0].conversion_uom_name :
                props.orderDetails.order_total_tons[0].conversion_uom_name_plural}
              </span>
            } {props.orderDetails.order_total_tons.length > 1 ? '...' : ''} */}
          </span>
        );
      }
      return (
        <span>
          <span>
            {" "}
            | <FormattedNumberCustom value={qty} />{" "}
            {qty === 1
              ? props.orderDetails.order_total_tons[0].input_uom_name
              : props.orderDetails.order_total_tons[0].input_uom_name_plural}
          </span>
          {props.orderDetails.order_total_tons[0].show_conversion && (
            <span>
              {" "}
              | <FormattedNumberCustom value={convertQty} />{" "}
              {convertQty === 1
                ? props.orderDetails.order_total_tons[0].conversion_uom_name
                : props.orderDetails.order_total_tons[0]
                    .conversion_uom_name_plural}
            </span>
          )}{" "}
          {props.orderDetails.order_total_tons.length > 1 ? "..." : ""}
        </span>
      );
    }
    return <span />;
  };

  showMaterialCost = (material) => {
    const { props } = this;
    const orderSys = props.user.settings_data.DIGITAL_ORDER_SYSTEM || "isSap";
    const price =
      (material.net_value / material.target_quantity) *
        material.ordered_quantity +
      (material.vat_percentage / 100) *
        ((material.net_value / material.target_quantity) *
          material.ordered_quantity);
    if (orderSys === "isJDE") {
      if (props.user.locale === "fr-CM") {
        console.log("material ====>", material, price, props.orderDetails);
        return (
          <div className="flexbox">
            <div>
              <span>Cost (VAT Inc)</span>
            </div>
            <FormattedCurrencyNumberCustom
              value={(
                price *
                (1 + props.orderDetails.businesses.tax_rate / 100)
              ).toFixed(2)}
            />
          </div>
        );
      } else {
        return (
          <div className="flexbox">
            <div>
              <span>Cost (VAT Exc)</span>
            </div>
            <FormattedCurrencyNumberCustom value={price.toFixed(2)} />
          </div>
        );
      }
    } else if (orderSys === "isSageAPI") {
      return (
        <div className="flexbox">
          <div>
            <span>Unit Price </span>
          </div>
          <FormattedCurrencyNumberCustom
            value={`${material.net_value.toFixed(2)}`}
          />
        </div>
      );
    } else if (orderSys === "isSage") {
      return (
        <div className="flexbox">
          <div>
            <span>Cost </span>
          </div>
          <FormattedCurrencyNumberCustom value={Math.round(price)} />
        </div>
      );
    }
    return (
      <div className="flexbox">
        <div>
          <span>Cost </span>
        </div>
        <FormattedCurrencyNumberCustom
          value={`${(
            (material.net_value / material.target_quantity) *
              material.ordered_quantity +
            (material.vat_percentage / 100) *
              ((material.net_value / material.target_quantity) *
                material.ordered_quantity)
          ).toFixed(2)}`}
        />
      </div>
    );
  };

  render() {
    const { state, props } = this;
    console.log("state.orderDetail,.,.,.,.,.,.,.,", state, props);
    const sdoStatuses =
      props.orderDetails &&
      (props.orderDetails.mode_of_delivery === "delivered" ||
        props.orderDetails.mode_of_delivery === "agency")
        ? state.ddpStatus
        : state.exwStatus;
    const showIvms = props.user.settings_data.SHOW_IVMS || false;
    console.log("sdoStatuses<><><", sdoStatuses);
    // let orderStatusIcon = '';
    let showIconForReceived = "";
    let iconReceived;
    let checkCurrent = false;
    let iconName = "";
    if (
      Number(state.orderDetail.customero_order_status_cd) === 1 ||
      Number(state.orderDetail.customero_order_status_cd) === 0
    ) {
      iconName = "icon-hour-glass";
    } else if (Number(state.orderDetail.customero_order_status_cd) === 2) {
      iconName = "icon-truck_fast";
    } else if (Number(state.orderDetail.customero_order_status_cd) === 3) {
      iconName = "icon-tick";
    } else if (Number(state.orderDetail.customero_order_status_cd) === 4) {
      iconName = "icon-cancel-order";
    }
    let errorMsg = "";
    const classes = {
      view: classNames("lr-make-sale lr-overlay order-detail-page", {}),
    };
    let orderHeading = "Order Status";
    const isDelivered =
      state.orderDetail.mode_of_delivery === "self_collect" ? false : true;
    return (
      <div className={classes.view}>
        <div className="lr-overlay__header">
          <div className="lr-overlay__header-title">
            <button
              type="button"
              className="lr-overlay__header-back-button"
              onClick={this.backPage}
            >
              <i className="icon-back" />
            </button>
            <span>Order Details</span>
          </div>
        </div>
        <div className="lr-overlay__body order-detail">
          <input
            type="file"
            accept="image/*"
            onChange={this.handleLogoFileUpload}
            ref={(inputFileLogo) => {
              this.inputLogoElement = inputFileLogo;
            }}
            style={{ display: "none" }}
          />
          <div
            className={
              this.state.divOpacity ? "page-body-invisible" : "lr-order-list"
            }
          >
            <div className="list-header flexbox">
              <h6>
                <span>Order</span>{" "}
                {state.orderDetail.logon_customer_order_number}
              </h6>
            </div>
            <div className="detail-order-summary flexbox">
              <div
                className={`order-details-icons icon-${
                  state.orderDetail && state.orderDetail.customer_order_status
                } ${
                  state.orderDetail.customero_order_status_cd === 4
                    ? "cancel-order-icon"
                    : ""
                }`}
              >
                <i className={iconName} />
              </div>
              <div className="detail-points">
                <div className="flexbox details-points-row">
                  <div className="details-points-box pad-right4">
                    <span>
                      {moment
                        .parseZone(state.orderDetail.creation_date)
                        .format("DD.MM.YYYY")}
                    </span>
                  </div>
                  {this.showUnitConditional()}
                  <div className="details-points-box">
                    {" "}
                    |
                    <span>
                      {" "}
                      {state.orderDetail &&
                      state.orderDetail.mode_of_delivery === "self_collect"
                        ? "Self Collect"
                        : state.orderDetail.mode_of_delivery === "agency"
                        ? "Agency"
                        : "Delivered"}
                    </span>
                  </div>
                </div>
                <div className="yellow-box">
                  <span>
                    {" "}
                    {state.orderDetail &&
                      state.orderDetail.customero_order_status_description}
                  </span>
                </div>
              </div>
            </div>
            <div className="long-details">
              <h4 className="detail-header">
                <span>Product Details</span>
              </h4>
              {/* {
                state.orderDetail.sap_order_line_items &&
                // <h4 className="detail-header"><FormattedMessage id="DigitalOrdering.ProductDetails" /></h4>
              } */}
              {state.orderDetail.sap_order_line_items &&
                state.orderDetail.sap_order_line_items.map((product) => {
                  const qty =
                    product.product_master.uom_code ===
                    product.product_master.input_uom
                      ? product.quantity
                      : product.quantity /
                        product.product_master.conversion_factor;
                  const convertQty =
                    product.product_master.uom_code ===
                    product.product_master.input_uom
                      ? product.quantity *
                        product.product_master.conversion_factor
                      : product.quantity;
                  return (
                    <div className="lr-product-row" key={product.id}>
                      <div className="lr-customer-row__product">
                        {product.product_master &&
                          product.product_master.image_data && (
                            <img src={product.product_master.image_data} />
                          )}
                      </div>
                      <div className="lr-customer-row__full-name">
                        <span className="overflow-ellipsis lr-customer-row__name">
                          <span>
                            {product.product_master
                              ? product.product_master.name
                              : product.material_description}
                          </span>
                        </span>
                        {
                          <span className="no-white-space lr-customer-row__last-payment">
                            <span>
                              <FormattedNumberCustom value={qty} />{" "}
                              {qty === 1
                                ? product.product_master.input_uom_name
                                : product.product_master.input_uom_name_plural}
                            </span>
                            {product.product_master.show_conversion && (
                              <span>
                                {" "}
                                | <FormattedNumberCustom
                                  value={convertQty}
                                />{" "}
                                {convertQty === 1
                                  ? product.product_master.conversion_uom_name
                                  : product.product_master
                                      .conversion_uom_name_plural}
                              </span>
                            )}
                          </span>
                        }
                      </div>
                    </div>
                  );
                })}
              <div className="lr-order-note-container">
                <h4 className="detail-header">
                  <span>Order Notes</span>
                </h4>
                <div className="additional-info">
                  <p>
                    <span>
                      <span>Local purchase order</span> :{" "}
                      {state.orderDetail.customer_ref_number
                        ? state.orderDetail.customer_ref_number
                        : "-"}
                    </span>
                  </p>
                  <p>
                    <span>
                      <span>Destination</span> :{" "}
                      {state.orderDetail.sap_business_site &&
                        state.orderDetail.sap_business_site.name}
                    </span>
                  </p>
                  {isDelivered &&
                    state.orderDetail &&
                    DELIVERY_INCO_TERM.includes(
                      state.orderDetail.mode_of_delivery
                    ) &&
                    state.orderDetail.delivery_address && (
                      <p>
                        <span>
                          <span>Delivery Address</span> :{" "}
                          {state.orderDetail.delivery_address &&
                          state.orderDetail.delivery_address === "ALL orders"
                            ? ""
                            : state.orderDetail.delivery_address}
                        </span>
                      </p>
                    )}
                  {state.orderDetail.delivery_date_from && (
                    <p>
                      <span>
                        <span>Delivery date from</span> :{" "}
                        {moment(state.orderDetail.delivery_date_from).format(
                          "DD.MM.YYYY"
                        )}
                      </span>
                    </p>
                  )}
                  {state.orderDetail.delivery_to_date && (
                    <p>
                      <span>
                        <span>Delivery to date</span> :{" "}
                        {moment(state.orderDetail.delivery_to_date).format(
                          "DD.MM.YYYY"
                        )}
                      </span>
                    </p>
                  )}
                </div>
                {/* <h4 className="detail-header"><FormattedMessage id="DigitalOrdering.orderNotes" /></h4> */}
                <div className="additional-info">
                  {/* {
                    (props.orderDetail || {}).customer_ref_number &&
                    <p><span><FormattedMessage id="DigitalOrdering.LPO" /> : {props.orderDetail.customer_ref_number}</span></p>
                  }
                  {
                    state.orderDetail && state.orderDetail.business_site &&
                    <p><span><FormattedMessage id="DigitalOrdering.Destination" /> : {state.orderDetail.business_site.name}</span></p>
                  }
                  {
                    state.orderDetail && state.orderDetail.mode_of_delivery === 'delivered' && state.orderDetail.delivery_address &&
                    <p><span><FormattedMessage id="DigitalOrdering.DeliveryAddress" /> : {state.orderDetail.delivery_address}</span></p>
                  } */}
                  {(state.orderDetail.customer_order_status === 0 ||
                    state.orderDetail.customer_order_status === 4) &&
                    errorMsg && (
                      <span>
                        {orderHeading}:
                        {/* {
                        orderFailedMsgArr.map(msg => (
                          <div>{msg}</div>
                        ))
                      } */}
                        {errorMsg && <div>{errorMsg}</div>}
                      </span>
                    )}
                </div>

                {state.orderDetail.sap_sdo_for_orders &&
                  state.orderDetail.sap_sdo_for_orders.length > 0 && (
                    <div className="deliveries-content ">
                      <h4 className="detail-header2">
                        <span>Deliveries</span>
                      </h4>

                      {state.orderDetail.sap_sdo_for_orders &&
                        state.orderDetail.sap_sdo_for_orders.map(
                          (sapSodOrder, index) => {
                            // console.log(
                            //   // "state.orderDetail==<><><><",
                            //   state.orderDetail
                            // );
                            // console.log("sapSodOrder ====>", sapSodOrder);
                            if (sapSodOrder.receive_full_order === null) {
                              // showIconForReceived = 'hour-glass';
                              iconReceived = "icon-hour-glass";
                              // currentStatus = sapSodOrder.order_status_description;
                            } else if (
                              sapSodOrder.receive_full_order === true
                            ) {
                              showIconForReceived = "received-yes";
                              iconReceived = "icon-tick";
                              // currentStatus = 'Received';
                            } else if (
                              sapSodOrder.receive_full_order === false
                            ) {
                              showIconForReceived = "received-no";
                              iconReceived = "icon-close";
                              // currentStatus = 'Not Received';
                            }
                            let exitPlantIcon = "";
                            if (
                              sapSodOrder.loading_date &&
                              ((sapSodOrder.truck_plate_no &&
                                sapSodOrder.truck_plate_no.trim()) ||
                                this.props.user.settings_data
                                  .DIGITAL_ORDER_SYSTEM === "isJDE")
                            ) {
                              exitPlantIcon = "icon-tick";
                            } else if (
                              Number(sapSodOrder.order_status) === 17
                            ) {
                              exitPlantIcon = "icon-close";
                            } else {
                              exitPlantIcon = "icon-hour-glass";
                            }
                            const orderSys =
                              props.user.settings_data.DIGITAL_ORDER_SYSTEM ||
                              "isManual";

                            return (
                              <div id={index}>
                                <div
                                  className={`single-deliveries ${
                                    sapSodOrder.receive_full_order === false ||
                                    sapSodOrder.receive_full_order === true
                                      ? showIconForReceived
                                      : "hour-glass"
                                  }  fullHeight ${
                                    Number(sapSodOrder.order_status) === 17
                                      ? "deleted-sdo"
                                      : ""
                                  }`}
                                >
                                  <div className="delivery-accordion active">
                                    <div
                                      id={index}
                                      className="accordion-header"
                                    >
                                      <i
                                        className={`${
                                          Number(
                                            state.orderDetail
                                              .customero_order_status_cd
                                          ) === 4
                                            ? ""
                                            : sapSodOrder.receive_full_order ===
                                                false ||
                                              sapSodOrder.receive_full_order ===
                                                true
                                            ? iconReceived
                                            : "icon-arrow-down-left "
                                        }`}
                                      />
                                      <span>Delivery</span> {index + 1}
                                      {((sapSodOrder.truck_plate_no &&
                                        sapSodOrder.order_status < 16 &&
                                        showIvms) ||
                                        (isDelivered &&
                                          sapSodOrder.truck_plate_no &&
                                          sapSodOrder.order_status >= 15 &&
                                          props.user.settings_data
                                            .IVMS_MIX_CAL_GROUP_ID &&
                                          this.state.currentDate.diff(
                                            moment.parseZone(
                                              sapSodOrder.loading_date
                                                ? sapSodOrder.loading_date
                                                : sapSodOrder.actual_delivery_date
                                            ),
                                            "hours"
                                          ) < 48)) && (
                                        <span
                                          className="location-map-button"
                                          onClick={() =>
                                            this.toggleMap(sapSodOrder, index)
                                          }
                                        >
                                          <img
                                            className="location-map-icon"
                                            src={LocationMapIcon}
                                            alt="location-map-icon"
                                          />
                                          <i
                                            className={`${
                                              state.openMap === index
                                                ? "icon-arrow_up"
                                                : "icon-arrow_down"
                                            }`}
                                          />
                                        </span>
                                      )}
                                    </div>
                                    {state.openMap === index ? (
                                      <div
                                        className={
                                          state.mapError
                                            ? "location-map-error"
                                            : "location-map"
                                        }
                                      >
                                        <Map
                                          mapData={state.mapData}
                                          mapError={state.mapError}
                                          isMapLoading={state.isMapLoading}
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <div
                                      id={index}
                                      className="accordion-content"
                                    >
                                      <div className="order-summary-list">
                                        <div className="summary-row">
                                          <i className="icon-tick"></i>
                                          <div className="inner-data">
                                            <p>
                                              <span>Loading Order Issued</span>
                                            </p>
                                            {sapSodOrder.logon_order_no && (
                                              <div className="inner-data">
                                                <div>
                                                  <span>Loading Number</span>
                                                </div>
                                                <span className="right-data">
                                                  {sapSodOrder.logon_order_no}
                                                </span>
                                              </div>
                                            )}
                                            {props.user.settings_data
                                              .DIGITAL_ORDER_SYSTEM ===
                                              "isJDE" && (
                                              <div className="inner-data">
                                                <div>
                                                  <span>Load Status</span>
                                                </div>
                                                <span className="right-data">
                                                  {sapSodOrder.load_status
                                                    ? sapSodOrder.load_status
                                                    : "-"}
                                                </span>
                                              </div>
                                            )}
                                            {
                                              <div className="inner-data">
                                                <div>
                                                  <span>Plant</span>
                                                </div>
                                                <span className="right-data">
                                                  {/* {state.orderDetail.sap_plant ? state.orderDetail.sap_plant.name :  ((props.orderDetail && props.orderDetail.sap_plant)|| {}).name} */}
                                                  {sapSodOrder?.sap_plant
                                                    ?.name ||
                                                    state.orderDetail?.sap_plant
                                                      ?.name}
                                                </span>
                                              </div>
                                            }
                                            {props.user.settings_data
                                              .DIGITAL_ORDER_SYSTEM ===
                                              "isJDE" && (
                                              <div className="inner-data">
                                                <div>
                                                  <span>Line + Shipment</span>
                                                </div>
                                                <span className="right-data">
                                                  {sapSodOrder.line_number
                                                    ? sapSodOrder.line_number
                                                    : ""}
                                                  {` - ${
                                                    sapSodOrder.shipment_number
                                                      ? sapSodOrder.shipment_number
                                                      : ""
                                                  }`}
                                                </span>
                                              </div>
                                            )}
                                            {props.user.settings_data
                                              .DIGITAL_ORDER_SYSTEM ===
                                              "isJDE" && (
                                              <div className="inner-data">
                                                <div>
                                                  <span>Shipment Status</span>
                                                </div>
                                                {/* <span className="right-data">{sapSodOrder.shipment_status ? sapSodOrder.shipment_status : '-'}</span> */}
                                              </div>
                                            )}
                                            {/* <div className="inner-data">
                                    <div>
                                      <span>Status</span>
                                    </div>
                                    { !sdoStatuses && <span className="right-data">{sapSodOrder.order_status_description}</span>}
                                  </div> */}
                                            {((props.user.settings_data
                                              .DIGITAL_ORDER_SYSTEM !==
                                              "isJDE" &&
                                              props.user.settings_data
                                                .DIGITAL_ORDER_SYSTEM !==
                                                "isSage") ||
                                              Number(
                                                sapSodOrder.order_status
                                              ) === 17) &&
                                              sapSodOrder.order_status_description && (
                                                <div className="inner-data">
                                                  <div>
                                                    <span>Status</span>
                                                  </div>
                                                  {!sdoStatuses &&
                                                    !(orderSys === "isSap") && (
                                                      <span className="right-data">
                                                        {
                                                          sapSodOrder.order_status_description
                                                        }
                                                      </span>
                                                    )}
                                                </div>
                                              )}

                                            <span className="right-data">
                                              {moment
                                                .parseZone(
                                                  sapSodOrder.creation_date
                                                )
                                                .format("HH:mm") === "00:00"
                                                ? moment
                                                    .parseZone(
                                                      sapSodOrder.creation_date
                                                    )
                                                    .format("DD.MM.YYYY")
                                                : moment
                                                    .parseZone(
                                                      sapSodOrder.creation_date
                                                    )
                                                    .format(
                                                      "DD.MM.YYYY | HH:mm"
                                                    )}
                                            </span>
                                          </div>
                                          <div className="status-timeline">
                                            {sdoStatuses &&
                                              sdoStatuses.map(
                                                (status, index) => {
                                                  console.log(
                                                    "status<><><",
                                                    status,
                                                    props.orderDetails
                                                  );
                                                  let statusClass =
                                                    "status-pending";
                                                  if (
                                                    status.toLowerCase() ===
                                                    sapSodOrder.order_status_description.toLowerCase()
                                                  ) {
                                                    // if last status is current then set statusClass to 'finished'
                                                    statusClass =
                                                      index + 1 ===
                                                      sdoStatuses.length
                                                        ? "status-finished"
                                                        : "status-current";
                                                    checkCurrent = true;
                                                  } else {
                                                    statusClass = checkCurrent
                                                      ? "status-pending"
                                                      : "status-finished";
                                                  }
                                                  return (
                                                    <p className={statusClass}>
                                                      <i className="icon-tick" />
                                                      {status}
                                                    </p>
                                                  );
                                                }
                                              )}
                                            {orderSys === "isJDE" && (
                                              <div>
                                                <p
                                                  className={
                                                    sapSodOrder.shipment_status_number >=
                                                      1 &&
                                                    sapSodOrder.shipment_status_number <=
                                                      23
                                                      ? "status-current"
                                                      : sapSodOrder.shipment_status_number >=
                                                        24
                                                      ? "status-finished"
                                                      : "status-pending"
                                                  }
                                                  key={1}
                                                >
                                                  <i className="icon-tick" />
                                                  New
                                                </p>
                                                {sapSodOrder.shipment_status_number <=
                                                  98 && (
                                                  <p
                                                    className={
                                                      sapSodOrder.shipment_status_number >=
                                                        25 &&
                                                      sapSodOrder.shipment_status_number <=
                                                        47
                                                        ? "status-current"
                                                        : sapSodOrder.shipment_status_number >=
                                                          48
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={2}
                                                  >
                                                    <i className="icon-tick" />
                                                    Approved
                                                  </p>
                                                )}
                                                {sapSodOrder.shipment_status_number <=
                                                  98 && (
                                                  <p
                                                    className={
                                                      sapSodOrder.shipment_status_number >=
                                                        49 &&
                                                      sapSodOrder.shipment_status_number <=
                                                        78
                                                        ? "status-current"
                                                        : sapSodOrder.shipment_status_number >=
                                                          79
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={3}
                                                  >
                                                    <i className="icon-tick" />
                                                    Dispatched
                                                  </p>
                                                )}
                                                {sapSodOrder.shipment_status_number <=
                                                  98 && (
                                                  <p
                                                    className={
                                                      sapSodOrder.shipment_status_number >=
                                                        80 &&
                                                      sapSodOrder.shipment_status_number <=
                                                        98
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={4}
                                                  >
                                                    <i className="icon-tick" />
                                                    Completed
                                                  </p>
                                                )}
                                                {sapSodOrder.shipment_status_number >=
                                                  99 && (
                                                  <p
                                                    className={
                                                      sapSodOrder.shipment_status_number >=
                                                      99
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={5}
                                                  >
                                                    <i className="icon-tick" />
                                                    Cancelled
                                                  </p>
                                                )}
                                              </div>
                                            )}
                                            {orderSys === "isSap" && (
                                              <div>
                                                <p
                                                  className={
                                                    Number(
                                                      sapSodOrder.order_status
                                                    ) === 1
                                                      ? "status-current"
                                                      : Number(
                                                          sapSodOrder.order_status
                                                        ) >= 1
                                                      ? "status-finished"
                                                      : "status-pending"
                                                  }
                                                  key={6}
                                                >
                                                  <i className="icon-tick" />
                                                  New
                                                </p>
                                                {Number(
                                                  sapSodOrder.order_status
                                                ) <= 16 && (
                                                  <p
                                                    className={
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) >= 2 &&
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) <= 5
                                                        ? "status-current"
                                                        : Number(
                                                            sapSodOrder.order_status
                                                          ) >= 5
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={7}
                                                  >
                                                    <i className="icon-tick" />
                                                    Approved
                                                  </p>
                                                )}
                                                {Number(
                                                  sapSodOrder.order_status
                                                ) <= 16 && (
                                                  <p
                                                    className={
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) >= 6 &&
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) <= 11
                                                        ? "status-current"
                                                        : Number(
                                                            sapSodOrder.order_status
                                                          ) >= 11
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={8}
                                                  >
                                                    <i className="icon-tick" />
                                                    Loading
                                                  </p>
                                                )}
                                                {Number(
                                                  sapSodOrder.order_status
                                                ) <= 16 && (
                                                  <p
                                                    className={
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) >= 12 &&
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) <= 14
                                                        ? "status-current"
                                                        : Number(
                                                            sapSodOrder.order_status
                                                          ) >= 14
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={9}
                                                  >
                                                    <i className="icon-tick" />
                                                    Shipped
                                                  </p>
                                                )}
                                                {Number(
                                                  sapSodOrder.order_status
                                                ) <= 16 && (
                                                  <p
                                                    className={
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) === 15
                                                        ? "status-current"
                                                        : Number(
                                                            sapSodOrder.order_status
                                                          ) >= 15
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={10}
                                                  >
                                                    <i className="icon-tick" />
                                                    Delivered
                                                  </p>
                                                )}
                                                {Number(
                                                  sapSodOrder.order_status
                                                ) <= 16 && (
                                                  <p
                                                    className={
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) === 16
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={11}
                                                  >
                                                    <i className="icon-tick" />
                                                    Completed
                                                  </p>
                                                )}
                                                {Number(
                                                  sapSodOrder.order_status
                                                ) >= 17 && (
                                                  <p
                                                    className={
                                                      Number(
                                                        sapSodOrder.order_status
                                                      ) >= 17
                                                        ? "status-finished"
                                                        : "status-pending"
                                                    }
                                                    key={12}
                                                  >
                                                    <i className="icon-tick" />
                                                    Cancelled
                                                  </p>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className={`summary-row ${
                                            ((sapSodOrder.truck_plate_no &&
                                              sapSodOrder.truck_plate_no.trim()) ||
                                              this.props.user.settings_data
                                                .DIGITAL_ORDER_SYSTEM ===
                                                "isJDE") &&
                                            sapSodOrder.loading_date &&
                                            Number(sapSodOrder.order_status) >=
                                              15
                                              ? ""
                                              : "hour-glass"
                                          } ${
                                            Number(sapSodOrder.order_status) ===
                                            17
                                              ? "received-no"
                                              : ""
                                          } `}
                                        >
                                          {/* sapSodOrder.receive_full_order === false */}
                                          <i className={exitPlantIcon} />
                                          <div className="inner-data">
                                            <p>
                                              <span>Exit plant</span>
                                              {sapSodOrder.loading_date && (
                                                <span className="right-data">
                                                  {moment
                                                    .parseZone(
                                                      sapSodOrder.loading_date
                                                    )
                                                    .format("HH:mm") === "00:00"
                                                    ? moment
                                                        .parseZone(
                                                          sapSodOrder.loading_date
                                                        )
                                                        .format("DD.MM.YYYY")
                                                    : moment
                                                        .parseZone(
                                                          sapSodOrder.loading_date
                                                        )
                                                        .format(
                                                          "DD.MM.YYYY | HH:mm"
                                                        )}
                                                </span>
                                              )}
                                            </p>
                                            <div className="created-details">
                                              {sapSodOrder.sap_materials_for_sdo
                                                .length > 0 &&
                                                sapSodOrder.sap_materials_for_sdo.map(
                                                  (sapSodMaterial) => {
                                                    let unitPrice = Number(
                                                      sapSodMaterial.price_per_unit
                                                    ).toFixed(2);
                                                    if (
                                                      props.user.locale ===
                                                      "fr-CM"
                                                    ) {
                                                      unitPrice = (
                                                        unitPrice *
                                                        (1 +
                                                          props.orderDetails
                                                            .businesses
                                                            .tax_rate /
                                                            100)
                                                      ).toFixed(2);
                                                    }
                                                    let qty =
                                                      sapSodMaterial
                                                        .product_master
                                                        .uom_code ===
                                                      sapSodMaterial
                                                        .product_master
                                                        .input_uom
                                                        ? sapSodMaterial.ordered_quantity
                                                        : sapSodMaterial.ordered_quantity /
                                                          sapSodMaterial
                                                            .product_master
                                                            .conversion_factor;
                                                    if (orderSys === "isSap") {
                                                      qty =
                                                        sapSodMaterial
                                                          .product_master
                                                          .uom_code ===
                                                        sapSodMaterial.ordered_qty_uom
                                                          ? sapSodMaterial.ordered_quantity
                                                          : sapSodMaterial.target_quantity;
                                                    }
                                                    let convertQty =
                                                      sapSodMaterial
                                                        .product_master
                                                        .uom_code ===
                                                      sapSodMaterial
                                                        .product_master
                                                        .input_uom
                                                        ? sapSodMaterial.ordered_quantity *
                                                          sapSodMaterial
                                                            .product_master
                                                            .conversion_factor
                                                        : sapSodMaterial.ordered_quantity;
                                                    if (orderSys === "isSap") {
                                                      convertQty =
                                                        sapSodMaterial
                                                          .product_master
                                                          .uom_code ===
                                                        sapSodMaterial.ordered_qty_uom
                                                          ? sapSodMaterial.ordered_quantity *
                                                            sapSodMaterial
                                                              .product_master
                                                              .conversion_factor
                                                          : sapSodMaterial.ordered_quantity;
                                                    }
                                                    return (
                                                      // console.log('--------->', sapSodMaterial.product_master ? sapSodMaterial.product_master.name : sapSodMaterial.sap_material_description)
                                                      <div className="product-map">
                                                        <div>
                                                          <div className="flexbox">
                                                            <div>
                                                              <span>
                                                                Product
                                                              </span>
                                                            </div>
                                                            <span>
                                                              {sapSodMaterial.product_master
                                                                ? sapSodMaterial
                                                                    .product_master
                                                                    .name
                                                                : sapSodMaterial.sap_material_description}
                                                            </span>
                                                          </div>
                                                          <div className="flexbox">
                                                            <div>
                                                              <span>
                                                                Quantity{" "}
                                                              </span>
                                                            </div>
                                                            <span>
                                                              <FormattedNumberCustom
                                                                value={qty}
                                                              />{" "}
                                                              <span>
                                                                {qty === 1
                                                                  ? sapSodMaterial
                                                                      .product_master
                                                                      .input_uom_name
                                                                  : sapSodMaterial
                                                                      .product_master
                                                                      .input_uom_name_plural}
                                                              </span>
                                                              {sapSodMaterial
                                                                .product_master
                                                                .show_conversion && (
                                                                <span>
                                                                  &nbsp;|{" "}
                                                                  <FormattedNumberCustom
                                                                    value={
                                                                      convertQty
                                                                    }
                                                                  />{" "}
                                                                  {convertQty ===
                                                                  1
                                                                    ? sapSodMaterial
                                                                        .product_master
                                                                        .conversion_uom_name
                                                                    : sapSodMaterial
                                                                        .product_master
                                                                        .conversion_uom_name_plural}
                                                                </span>
                                                              )}
                                                            </span>
                                                          </div>
                                                          {props.user
                                                            .settings_data
                                                            .DIGITAL_ORDER_SYSTEM ===
                                                            "isSageAPI" && (
                                                            <div className="flexbox">
                                                              <div>
                                                                <span>
                                                                  Unit Price{" "}
                                                                </span>
                                                              </div>
                                                              <FormattedCurrencyNumberCustom
                                                                value={`${sapSodMaterial.net_value.toFixed(
                                                                  2
                                                                )}`}
                                                                currency={
                                                                  state
                                                                    .orderDetail
                                                                    .currency
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                          {props.user
                                                            .settings_data
                                                            .DIGITAL_ORDER_SYSTEM ===
                                                            "isJDE" &&
                                                            props.user
                                                              .locale !==
                                                              "fr-CM" && (
                                                              <div className="flexbox">
                                                                <div>
                                                                  <span>
                                                                    Price Per
                                                                    Unit (VAT
                                                                    Exc){" "}
                                                                  </span>
                                                                </div>
                                                                <span>
                                                                  <FormattedCurrencyNumberCustom
                                                                    value={
                                                                      unitPrice
                                                                    }
                                                                  />
                                                                </span>
                                                              </div>
                                                            )}
                                                          {props.user
                                                            .settings_data
                                                            .DIGITAL_ORDER_SYSTEM ===
                                                            "isJDE" &&
                                                            props.user
                                                              .locale ===
                                                              "fr-CM" && (
                                                              <div className="flexbox">
                                                                <div>
                                                                  <span>
                                                                    Price Per
                                                                    Unit (VAT
                                                                    Inc){" "}
                                                                  </span>
                                                                </div>
                                                                <span>
                                                                  <FormattedCurrencyNumberCustom
                                                                    value={
                                                                      unitPrice
                                                                    }
                                                                  />
                                                                </span>
                                                              </div>
                                                            )}
                                                          {props.user
                                                            .settings_data
                                                            .DIGITAL_ORDER_SYSTEM !==
                                                            "isSageAPI" &&
                                                            this.showMaterialCost(
                                                              sapSodMaterial
                                                            )}
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              {sapSodOrder.lsd_order_no && (
                                                <div className="flexbox">
                                                  <div>
                                                    <span>Delivery Note</span>
                                                  </div>
                                                  <span>
                                                    <span className="custom-formated-currency">
                                                      {sapSodOrder.lsd_order_no}{" "}
                                                    </span>{" "}
                                                  </span>
                                                  {/* <span>&nbsp;| <span className="custom-formated-currency">20</span> Bags</span> */}
                                                </div>
                                              )}
                                              {sapSodOrder.truck_plate_no &&
                                                orderSys !== "isJDE" &&
                                                orderSys !== "isMulesoft" && (
                                                  <div className="product-map">
                                                    <div className="flexbox">
                                                      <div>
                                                        <span>
                                                          Truck and Driver
                                                          Details
                                                        </span>
                                                      </div>
                                                      {sapSodOrder.truck_plate_no !==
                                                        "-" &&
                                                      sapSodOrder.truck_plate_no !==
                                                        "-" ? (
                                                        <span>
                                                          <span>
                                                            <span className="custom-formated-currency">
                                                              {
                                                                sapSodOrder.truck_plate_no
                                                              }{" "}
                                                            </span>
                                                          </span>
                                                          {sapSodOrder.driver_details !==
                                                            "-" && (
                                                            <span>
                                                              {" "}
                                                              {
                                                                sapSodOrder.driver_details
                                                              }
                                                            </span>
                                                          )}
                                                          {/* <span>&nbsp;| <span className="custom-formated-currency">20</span> Bags</span> */}
                                                        </span>
                                                      ) : (
                                                        <span>-</span>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                              {sapSodOrder.truck_plate_no &&
                                                orderSys !== "isMulesoft" &&
                                                orderSys === "isJDE" && (
                                                  <div className="product-map">
                                                    <div className="flexbox">
                                                      <div>
                                                        <span>
                                                          Truck & Driver Details
                                                        </span>
                                                      </div>
                                                      {sapSodOrder.truck_plate_no !==
                                                        "-" &&
                                                      sapSodOrder.truck_plate_no !==
                                                        "-" ? (
                                                        <span>
                                                          <span>
                                                            <span className="custom-formated-currency">
                                                              {
                                                                sapSodOrder.truck_plate_no
                                                              }
                                                              &#44;&nbsp;
                                                            </span>
                                                          </span>
                                                          {sapSodOrder.driver_details !==
                                                            "-" && (
                                                            <span>
                                                              {" "}
                                                              {
                                                                sapSodOrder.driver_details
                                                              }
                                                            </span>
                                                          )}
                                                          {/* <span>&nbsp;| <span className="custom-formated-currency">20</span> Bags</span> */}
                                                        </span>
                                                      ) : (
                                                        <span>-</span>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                              {sapSodOrder.truck_plate_no &&
                                                orderSys === "isMulesoft" && (
                                                  <div className="product-map">
                                                    <div className="flexbox">
                                                      <div>
                                                        <span>
                                                          Truck and Driver
                                                          Details
                                                        </span>
                                                      </div>
                                                      {sapSodOrder.truck_plate_no !==
                                                        "-" &&
                                                      sapSodOrder.truck_plate_no !==
                                                        "-" ? (
                                                        <span>
                                                          <span>
                                                            <span className="custom-formated-currency">
                                                              {
                                                                sapSodOrder.truck_plate_no
                                                              }
                                                              &#44;&nbsp;
                                                            </span>
                                                          </span>
                                                          {sapSodOrder.truck_drive_details !==
                                                            "-" && (
                                                            <span>
                                                              {" "}
                                                              {
                                                                sapSodOrder.truck_drive_details
                                                              }
                                                            </span>
                                                          )}
                                                        </span>
                                                      ) : (
                                                        <span>-</span>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        </div>
                                        {isDelivered &&
                                          (sapSodOrder.receive_full_order ===
                                            true ||
                                            (((sapSodOrder.truck_plate_no &&
                                              sapSodOrder.truck_plate_no.trim()) ||
                                              this.props.user.settings_data
                                                .DIGITAL_ORDER_SYSTEM ===
                                                "isJDE") &&
                                              sapSodOrder.loading_date &&
                                              sapSodOrder.receive_full_order ===
                                                null)) &&
                                          !this.props.user.settings_data
                                            .HIDE_RECEIVED_YES_NO && (
                                            <div
                                              className={`summary-row ${
                                                sapSodOrder.receive_full_order ===
                                                null
                                                  ? "hour-glass"
                                                  : "received-yes"
                                              }`}
                                            >
                                              <i className={iconReceived} />
                                              <div className="inner-data">
                                                <p>
                                                  <span>Received</span>
                                                </p>
                                              </div>
                                            </div>
                                          )}

                                        {sapSodOrder.receive_full_order ===
                                          false && (
                                          <div className="summary-row received-no">
                                            <i className={iconReceived} />
                                            <div className="inner-data">
                                              <p>
                                                <span>Not received</span>
                                              </p>
                                              <div className="lr-image-container">
                                                <div className="lr-image-dispute">
                                                  {sapSodOrder &&
                                                    sapSodOrder.sap_sdo_disputes_data &&
                                                    sapSodOrder.receive_full_order ===
                                                      false &&
                                                    sapSodOrder.sap_sdo_disputes_data.map(
                                                      (
                                                        disputes_data,
                                                        index
                                                      ) => {
                                                        const imgUrl =
                                                          JSON.parse(
                                                            disputes_data.receive_order_image_data
                                                          );

                                                        return (
                                                          <div>
                                                            <img
                                                              src={
                                                                imgUrl.metadata
                                                                  .filename
                                                              }
                                                            />
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="inner-data">
                                              <p>
                                                <span>Comment</span> -{" "}
                                                {sapSodOrder.receive_order_note}
                                              </p>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                      {((sapSodOrder.truck_plate_no &&
                                        sapSodOrder.truck_plate_no.trim()) ||
                                        this.props.user.DIGITAL_ORDER_SYSTEM ===
                                          "isJDE") &&
                                        (state.orderDetail.mode_of_delivery ===
                                          "delivered" ||
                                          state.orderDetail.mode_of_delivery ===
                                            "agency") &&
                                        sapSodOrder.loading_date &&
                                        sapSodOrder.receive_full_order ===
                                          null &&
                                        !this.props.user
                                          .HIDE_RECEIVED_YES_NO && (
                                          <div className="delivery-footer flexbox">
                                            <p>
                                              <span>
                                                Received full quantity?
                                              </span>
                                            </p>
                                            <div className="right-data flexbox">
                                              <div className="lr-input-row checkbox-test">
                                                <input
                                                  type="checkbox"
                                                  placeholder=""
                                                  id="2444"
                                                  className="lr-text-input__input"
                                                  value="yes"
                                                  disabled
                                                />
                                                <label htmlFor="2444">
                                                  <span>YES</span>
                                                </label>
                                              </div>
                                              <div className="lr-input-row checkbox-test">
                                                <input
                                                  type="checkbox"
                                                  placeholder=""
                                                  id="2444"
                                                  className="lr-text-input__input"
                                                  value="no"
                                                  disabled
                                                />
                                                <label htmlFor="2444">
                                                  <span>NO</span>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {/* <div className="delivery-footer flexbox">
                                <p><span>Received full quantity?</span></p>
                                <p><span>-</span></p>
                              </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                    </div>
                  )}

                {(state.orderDetail.customer_order_status === 0 ||
                  state.orderDetail.customer_order_status === 4) && (
                  <div className="pending-note">
                    <i className="note-icon">i</i>
                    {/* {
                      SAP_ENABLE === true &&
                      <FormattedMessage id="DigitalOrdering.PendingNote" />
                    }
                      {
                      SAP_ENABLE === false &&
                      <FormattedMessage id="DigitalOrdering.PendingOrderStatus" />
                    } */}
                  </div>
                )}
              </div>
              {/* <Deliveries orderProps={state} orderDetail={state.orderDetail} user={props.user} /> */}
            </div>
          </div>
        </div>
        {state.showLoader && (
          <div>
            <LoadingState />
            <div className="loadingContainer" />
          </div>
        )}
      </div>
    );
  }
}

export default OrderDetail;
